import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Backdrop from '@mui/material/Backdrop';
import Fade from '@mui/material/Fade';

function PositionListedSuccessModal({ open, handleClose, mockData }) {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={open}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: 400,
          bgcolor: 'background.paper',
          borderRadius: '24px',
          boxShadow: 24,
          p: 4,
          outline: 'none',
          textAlign: 'center'
        }}>
          {/* Success Icon - Green badge with checkmark */}
          <div className="mt-6 mb-6">
            <div className="w-24 h-24 mx-auto relative flex items-center justify-center">
              {/* Badge shape using SVG */}
              <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M48 4L56.5 12.5L68 8L72.5 20L84 24.5L80 36L88.5 44.5L80 53L84 64.5L72.5 69L68 80.5L56.5 76L48 84.5L39.5 76L28 80.5L23.5 69L12 64.5L16 53L7.5 44.5L16 36L12 24.5L23.5 20L28 8L39.5 12.5L48 4Z" fill="#E8F5E9" stroke="#00BC67" strokeWidth="2"/>
                <path d="M34 48L44 58L62 38" stroke="#00BC67" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </div>
          
          <h2 className="text-[#1E222B] text-[22px] font-bold mb-3">Position Listed!</h2>
          <p className="text-[#808285] text-[14px] leading-relaxed mb-8 px-2">
            Your {mockData?.units || "0"} unit position in the {mockData?.title || "project"} has been listed on the Secondary Market. You'll be notified when a buyer takes your position.
          </p>
          
          {/* Listed details */}
          <div className="bg-[#F8FAFC] rounded-xl p-4 mb-8 text-left">
            <div className="flex justify-between py-2.5">
              <p className="text-[#808285] text-[13px]">Units Listed</p>
              <p className="text-back-color2 text-[13px] font-bold">{mockData?.units || "0"} units</p>
            </div>
            <div className="flex justify-between py-2.5">
              <p className="text-[#808285] text-[13px]">Listed value</p>
              <p className="text-back-color2 text-[13px] font-bold">{mockData?.estimatedPositionValue || "N/A"}</p>
            </div>
            <div className="flex justify-between py-2.5">
              <p className="text-[#808285] text-[13px]">Listed on</p>
              <p className="text-back-color2 text-[13px] font-bold">Secondary Market</p>
            </div>
          </div>
          
          <button 
            onClick={handleClose}
            className="w-full py-3.5 bg-[#00BC67] text-white rounded-lg font-[600] text-[15px]"
          >
            Done
          </button>
        </Box>
      </Fade>
    </Modal>
  );
}

export default PositionListedSuccessModal;
